import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

interface IErrors {
  minlength?: string;
  maxlength?: string;
  min?: string;
  max?: string;
  email?: string;
  password?: string;
  pattern?: string;
}

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss']
})
export class PasswordComponent implements OnInit {

  @Input() public control: FormControl; /**Form control of the input */
  @Input() public group: FormGroup; /**Form group of the input */
  @Input() public placeHolder; /**Place holder of that input */
  @Input() public errorMessage: IErrors; /**Error Messages of perticular input */
  @Input() public fieldRequired = 'Field required';

  hide = true;
  public error;

  constructor() { }

  ngOnInit() {
  }

  checkError() {
    if (this.control && this.control.invalid && this.control.touched) {
      this.error = this.control.invalid;
    }
  }

}
